/**
 * @generated SignedSource<<0ae1d220d98021c731c43c471d9f1687>>
 * @relayHash c8022b1e8079f1674be6b489d3c9cf28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 62e152d2982e35fff9a67e39b3d4cad463e06464567676755afa0dd092f7981a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditPermissionSchemesQuery$variables = {
  first?: number | null;
  isGrantsPerPermissionLimitEnabled: boolean;
  schemeId: string;
};
export type EditPermissionSchemesQuery$data = {
  readonly jira: {
    readonly getProjectsByPermissionScheme: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly projectId: string;
        };
      } | null>;
    };
    readonly viewPermissionScheme: {
      readonly configuration?: {
        readonly isEditable: boolean;
      };
      readonly scheme?: {
        readonly name: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"Header_PermissionsAdministrationPagesEditPermissionScheme" | "PermissionCategories">;
    };
  } | null;
};
export type EditPermissionSchemesQuery = {
  response: EditPermissionSchemesQuery$data;
  variables: EditPermissionSchemesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGrantsPerPermissionLimitEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemeId"
},
v3 = {
  "kind": "Variable",
  "name": "schemeId",
  "variableName": "schemeId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "isEditable"
},
v8 = {
  "concreteType": "JiraPermissionSchemeConfiguration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v9 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v3/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "description"
},
v14 = {
  "kind": "ScalarField",
  "name": "text"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = [
  (v11/*: any*/),
  (v5/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v5/*: any*/),
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditPermissionSchemesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v4/*: any*/),
              "kind": "LinkedField",
              "name": "viewPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "isGrantsPerPermissionLimitEnabled",
                          "variableName": "isGrantsPerPermissionLimitEnabled"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "PermissionCategories"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "Header_PermissionsAdministrationPagesEditPermissionScheme"
                    },
                    {
                      "concreteType": "JiraPermissionScheme",
                      "kind": "LinkedField",
                      "name": "scheme",
                      "plural": false,
                      "selections": (v6/*: any*/)
                    },
                    (v8/*: any*/)
                  ],
                  "type": "JiraPermissionSchemeView"
                }
              ]
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": (v9/*: any*/),
              "concreteType": "JiraProjectConnection",
              "kind": "LinkedField",
              "name": "getProjectsByPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraProject",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v10/*: any*/),
                              "action": "LOG"
                            }
                          ]
                        },
                        "action": "LOG"
                      }
                    ]
                  },
                  "action": "LOG"
                }
              ]
            },
            "action": "LOG"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPermissionSchemesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "viewPermissionScheme",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraPermissionSchemeGrantGroup",
                    "kind": "LinkedField",
                    "name": "grantGroups",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectPermissionCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraPermissionGrantHolder",
                        "kind": "LinkedField",
                        "name": "grantHolders",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProjectPermission",
                            "kind": "LinkedField",
                            "name": "permission",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v13/*: any*/),
                              (v12/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraPermissionConfiguration",
                            "kind": "LinkedField",
                            "name": "configuration",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "tag"
                              },
                              {
                                "concreteType": "JiraPermissionMessageExtension",
                                "kind": "LinkedField",
                                "name": "message",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v14/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraPermissionDocumentationExtension",
                                "kind": "LinkedField",
                                "name": "documentation",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraPermissionGrants",
                            "kind": "LinkedField",
                            "name": "grants",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraGrantTypeKey",
                                "kind": "LinkedField",
                                "name": "grantType",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v5/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraPermissionGrantValue",
                                "kind": "LinkedField",
                                "name": "grantValues",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v6/*: any*/),
                                        "type": "JiraDefaultGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v16/*: any*/)
                                          }
                                        ],
                                        "type": "JiraUserGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraGroup",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": (v17/*: any*/)
                                          }
                                        ],
                                        "type": "JiraGroupGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraRole",
                                            "kind": "LinkedField",
                                            "name": "role",
                                            "plural": false,
                                            "selections": (v17/*: any*/)
                                          }
                                        ],
                                        "type": "JiraProjectRoleGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": (v16/*: any*/)
                                          }
                                        ],
                                        "type": "JiraIssueFieldGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v15/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ]
                                  },
                                  (v15/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "totalCount"
                              },
                              (v11/*: any*/),
                              {
                                "condition": "isGrantsPerPermissionLimitEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "grantsPerPermissionLimit"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraPermissionScheme",
                    "kind": "LinkedField",
                    "name": "scheme",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ],
                "type": "JiraPermissionSchemeView"
              }
            ]
          },
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "getProjectsByPermissionScheme",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "62e152d2982e35fff9a67e39b3d4cad463e06464567676755afa0dd092f7981a",
    "metadata": {},
    "name": "EditPermissionSchemesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c599647c7d5ef5e1eb4d840484af9fe";

export default node;
